export default [
    {
        path: '/licenses',
        name: 'licenses',
        component: () => import ('./pages/licenseRegister')
    },
]